/**
 * Retention Period Constants
 *
 * Defines retention periods for various data types in the platform.
 * Each retention period includes both user-facing display units and minute-based units
 * for calculations.
 */

/**
 * Flow Run Logs Retention
 * Logs are retained for a specific period and then purged.
 */
export const FLOW_RUN_LOGS_RETENTION = {
  /** Display text for user-facing messages (e.g., error messages, tooltips) */
  DISPLAY_UNIT: '30 days',
  /** Retention period in minutes */
  MINUTES: 30 * 24 * 60, // 30 days * 24 hours * 60 minutes
  /** Retention period in milliseconds (for timestamp calculations) */
  MILLISECONDS: 30 * 24 * 60 * 60 * 1000, // 30 days * 24 hours * 60 minutes * 60 seconds * 1000 ms
} as const;

/**
 * Helper function to get the timestamp for the retention cutoff date
 * @returns Timestamp in milliseconds representing the retention cutoff (now - retention period)
 */
export const getFlowRunLogsRetentionCutoff = (): number => {
  return new Date().getTime() - FLOW_RUN_LOGS_RETENTION.MILLISECONDS;
};

/**
 * Type exports for better TypeScript support
 */
export type RetentionPeriod = {
  DISPLAY_UNIT: string;
  MINUTES: number;
  MILLISECONDS: number;
};
